import Vue from 'vue';
import ProfessionalWidget from './components/Widget/Widget';

Object.defineProperty(Vue.prototype, '$bus', {
  get() {
    return this.$root.bus;
  },
});

new Vue({
  el: '#app',

  components: { ProfessionalWidget },

  data: {
    bus: new Vue({}),
  },
});
